module.exports = __webpack_public_path__ + "static/img/far2_active.7831c251.png";